(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image"] && !Shopify.designMode) return;
  try {
    
(function () {
  const items = document.querySelectorAll('.section-image-item[data-countdown-target]');

  items.forEach(function (el) {
    const targetStr = el.dataset.countdownTarget;
    const timezone = el.dataset.countdownTimezone || 'UTC';

    function getTargetMs() {
      const [datePart, timePart] = targetStr.split('T');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);

      const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      });
      const parts = formatter.formatToParts(utcDate);
      const p = {};
      parts.forEach(function (x) { p[x.type] = x.value; });
      const localMs = Date.UTC(
        Number(p.year), Number(p.month) - 1, Number(p.day),
        Number(p.hour) % 24, Number(p.minute), Number(p.second)
      );
      const offset = localMs - utcDate.getTime();
      return utcDate.getTime() - offset;
    }

    const targetMs = getTargetMs();

    function check() {
      if (Date.now() >= targetMs) {
        el.removeAttribute('hidden');
        clearInterval(timer);
      }
    }

    check();
    const timer = setInterval(check, 1000);
  });

  if (!window.__anuaAmazonStrictOnceListenerAdded) {
    window.__anuaAmazonStrictOnceListenerAdded = true;
    window.__anuaAmazonStrictOnceTracked = false;

    document.addEventListener(
      'click',
      function (event) {
        const link = event.target.closest('[data-amazon-page-once]');
        if (!link) return;

        const href = link.href || '';
        const outboundUrl = href.toLowerCase();

        // Only track links whose outbound URL contains "amazon".
        // Non-Amazon links continue with their normal click behavior.
        if (!outboundUrl.includes('amazon')) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (!window.__anuaAmazonStrictOnceTracked) {
          const shopifyAnalytics = window.Shopify && window.Shopify.analytics;

          if (shopifyAnalytics && typeof shopifyAnalytics.publish === 'function') {
            window.__anuaAmazonStrictOnceTracked = true;

            shopifyAnalytics.publish('anua:amazon_click', {
              product_id: link.dataset.productId || '',
              destination: link.dataset.destination || 'amazon',
              page_path: window.location.pathname,
              outbound_url: href
            });
          }
        }

        window.open(href, '_blank', 'noopener,noreferrer');
      },
      true
    );
  }
})();

  } catch(e) { console.error(e); }
})();
})();
